import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { CustomerActions } from "src/core/customers/store/customers.actions";
import * as AT from "src/core/customers/store/customers.constants";
import type { ICustomer } from "src/core/customers/api/customers.api";

export interface ICustomersStore {
  customer: ICustomer | null;
}

const initialState: ICustomersStore = { customer: null };

export const customersReducer: Redux.Reducer<ICustomersStore> = (state: ICustomersStore = initialState, action: CustomerActions): ICustomersStore => {
  switch (action.type) {
    case AT.PURGE_CUSTOMERS:
      return initialState;

    case AT.SET_CUSTOMER:
      return {
        ...state,
        customer: action.customer
      };

    default:
      return state;
  }
};

export const customersPersistConfig = {
  key: "customers",
  storage,
  blacklist: [ "" ]
};
